import React, { forwardRef } from 'react';
import { Cpu, Layers, DollarSign, ScanFace } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import PremiumUpsell from '../ui/PremiumUpsell';
import { formatK } from './utils';

/**
 * NicheFinderUpsell — copy e números do Niche Finder em cima do card de
 * venda genérico (ui/PremiumUpsell). `pulseKey` retriggera o pulso do CTA.
 */
const NicheFinderUpsell = forwardRef(({ stats, planType, pulseKey = 0 }, ref) => {
  const { t } = useTranslation();

  const total = stats?.total_active ?? 0;
  const weekly = stats?.weekly_new ?? 0;

  return (
    <PremiumUpsell
      ref={ref}
      badge={t('viralNiches.upsell_badge')}
      headline={t('viralNiches.upsell_headline')}
      subhead={t('viralNiches.upsell_subhead', { total: formatK(total) })}
      statItems={[
        { value: formatK(total), label: t('viralNiches.upsell_stat_channels') },
        { value: `+${weekly}`, label: t('viralNiches.upsell_stat_weekly') },
        { value: '7', label: t('viralNiches.upsell_stat_tiers') },
      ]}
      bullets={[
        { Icon: Cpu, text: t('viralNiches.upsell_bullet_algorithm') },
        { Icon: Layers, text: t('viralNiches.upsell_bullet_tiers') },
        { Icon: DollarSign, text: t('viralNiches.upsell_bullet_monetization') },
        { Icon: ScanFace, text: t('viralNiches.upsell_bullet_score') },
      ]}
      urgencyText={t('viralNiches.upsell_urgency', { count: weekly })}
      ctaLabel={t('viralNiches.upsell_cta')}
      planType={planType}
      pulseKey={pulseKey}
    />
  );
});

NicheFinderUpsell.displayName = 'NicheFinderUpsell';

export default NicheFinderUpsell;
